<template>
  <div class="search w" v-loading="searchLoading">
    <!--选择区域-->
    <div class="selectArea">
      <!--商品类别-->
      <div class="satelliteClass">
        <div class="satelliteTitle">
          <span class="type">商品类型</span>
        </div>
        <div class="satelliteWrap">
          <el-radio-group v-model="goodactiveName" @change="GoodCategoryChange">
            <el-radio-button v-for="(value,key,index) in GoodCategory" :key="index" :label="key">
              {{ value }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div v-if="goodactiveName === '1'">
        <!-- 卫星分类 -->
        <div class="satelliteClass">
          <div class="satelliteTitle">
            <span class="type">卫星类型</span>
          </div>
          <div class="satelliteWrap">
            <el-radio-group v-model="activeName" @change="sateChange">
              <el-radio-button v-for="(item,index) in classData" :key="index" :label="item.id">
                {{ item.satelliteName }}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <!-- 卫星子类 -->
        <div class="satelliteSonClass" v-if="activeName != 1">
          <div class="satelliteTitle">
            <span class="type">卫星</span>
          </div>
          <div class="satelliteWrap">
            <el-checkbox-group v-model="sateSonName">
              <el-checkbox-button v-for="(item,index) in sateSonData" :key="index" :label="item.id"
                                  @change="sateSonChange(item.id,item.satelliteName)">{{ item.satelliteName }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </div>
        <!-- 卫星等级 -->
        <div class="satelliteLevel">
          <div class="satelliteTitle">
            <span class="type">产品等级</span>
          </div>
          <div class="satelliteWrap">
            <el-checkbox-group v-model="levelActiveName" @change="sateLevelChange">
              <el-checkbox-button v-for="(item,index) in satelliteLevel" :key="index" :label="item">
                {{ item }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </div>
        <!-- 卫星分辨率 -->
        <div class="satelliteResolve">
          <div class="satelliteTitle">
            <span class="type">分辨率</span>
          </div>
          <div class="satelliteWrap">
            <el-checkbox-group v-model="resolveActiveName" @change="resolveChange">
              <el-checkbox-button v-for="(item,index) in satelliteResolve" :key="index" :label="item.value">
                {{ item.name }}
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </div>
        <!-- 行业分类 -->
        <div class="satelliteIndustry">
          <div class="satelliteTitle">
            <span class="type">行业分类</span>
          </div>
          <div class="satelliteWrap">
            <el-radio-group v-model="industyActiveName" @change="industyChange">
              <el-radio-button v-for="(item,index) in plateClass" :key="index" :label="item.id">
                {{ item.plateName }}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <!-- 价格排序 -->
        <div class="priceSort">
          <div class="satelliteTitle">
            <span class="type">排序</span>
          </div>
          <div class="satelliteWrap">
            <el-radio-group v-model="priceSortName" @change="priceSortChange">
              <el-radio-button v-for="(item,index) in priceSortClass" :key="index" :label="item.id">
                {{ item.label }}
                <i :class="item.iconClass" style="font-weight:bold;"></i>
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>

      <div v-else-if="goodactiveName === '2'">
        <!-- 行业分类 -->
        <div class="satelliteIndustry">
          <div class="satelliteTitle">
            <span class="type">行业分类</span>
          </div>
          <div class="satelliteWrap">
            <el-radio-group v-model="industyActiveName" @change="industyChange">
              <el-radio-button v-for="(item,index) in plateClass" :key="index" :label="item.id">
                {{ item.plateName }}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <!-- 价格排序 -->
        <div class="priceSort">
          <div class="satelliteTitle">
            <span class="type">排序</span>
          </div>
          <div class="satelliteWrap">
            <el-radio-group v-model="priceSortName" @change="priceSortChange">
              <el-radio-button v-for="(item,index) in priceSortClass" :key="index" :label="item.id">
                {{ item.label }}
                <i :class="item.iconClass" style="font-weight:bold;"></i>
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>

      <div v-else>
        <!-- 行业分类 -->
        <div class="satelliteIndustry">
          <div class="satelliteTitle">
            <span class="type">软件分类</span>
          </div>
          <div class="satelliteWrap">
            <el-radio-group v-model="goodid" @change="goodChange">
              <el-radio-button v-for="(item,index) in ClassificationOfGoods" :key="index" :label="item.id">
                {{ item.name }}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>

        <!-- 价格排序 -->
        <div class="priceSort">
          <div class="satelliteTitle">
            <span class="type">排序</span>
          </div>
          <div class="satelliteWrap">
            <el-radio-group v-model="priceSortName" @change="priceSortChange">
              <el-radio-button v-for="(item,index) in priceSortClass" :key="index" :label="item.id">
                {{ item.label }}
                <i :class="item.iconClass" style="font-weight:bold;"></i>
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>

    <!--勾选卫星提示-->
    <div class="sort">
      <div class="currentSelect" v-if="activeName != 1">
        <span class="currentSelectTitle">已勾选卫星：</span>
        <p class="tagSatellite">
          <el-tag @close="removeSatelliteFun(item,index)" v-for="(item,index) in currentSelectArray" :key="index"
                  closable>
            {{ item }}
          </el-tag>
        </p>
      </div>
      <div class="currentSelect" v-else>
        已勾选卫星： <p><span>全部</span></p>
      </div>
      <div>
        共<span style="color: #3868e9;font-weight: 600">{{ total }}</span>个数据
      </div>
    </div>

    <!--展示区域-->
    <div class="Display_area">
      <div class="display_area_box" v-if="goodList.length > 0">
        <good v-for="(good,index) in goodList" :key="index" :good="good"></good>
      </div>
      <div class="nothing" v-else>
        <nothing></nothing>
      </div>
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-size="pagesize" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Good from "@/views/Search/Good";
import nothing from "@/components/nothing.vue";
import {ClassificationOfGoods} from "@/const/RemoteSensingMall";

export default {
  name: "search",
  components: {
    Good,
    nothing
  },
  watch: {
  },
  data() {
    return {
      ClassificationOfGoods: [],
      goodid: '',

      goodactiveName: '1',
      GoodCategory: {
        1: '基础数据',
        2: '数据产品',
        3: '软件工具'
      },
      searchLoading: false,
      currentPage: 1,
      pagesize: 8,
      total: 0,
      // 卫星系列类型
      classData: [],
      // 子卫星数据
      sateSonData: [],
      // 卫星等级
      satelliteLevel: [],
      // 产品分辨率
      satelliteResolve: [
        {name: '0.5m', value: '0.5'},
        {name: '1m', value: '1'},
        {name: '2m', value: '2'},
        {name: '8m', value: '8'},
        {name: '16m', value: '16'},
      ],
      plateClass: [],
      goodList: [
        {
          name: 'GF1 WFV3 分辨率0.5m L1级数据',
          price: '3000.00',
          date: '2019-02-02',
          img: require('./good.png'),
          tag1: 'GF1',
          tag2: '10m',
          command: '500+条'
        },
        {
          name: 'GF1 WFV3 分辨率0.5m L1级数据',
          price: '3000.00',
          date: '2019-02-02',
          img: require('./good.png'),
          tag1: 'GF1',
          tag2: '10m',
          command: '500+条'
        },
        {
          name: 'GF1 WFV3 分辨率0.5m L1级数据',
          price: '3000.00',
          date: '2019-02-02',
          img: require('./good.png'),
          tag1: 'GF1',
          tag2: '10m',
          command: '500+条'
        },
        {
          name: 'GF1 WFV3 分辨率0.5m L1级数据',
          price: '3000.00',
          date: '2019-02-02',
          img: require('./good.png'),
          tag1: 'GF1',
          tag2: '10m',
          command: '500+条'
        },
        {
          name: 'GF1 WFV3 分辨率0.5m L1级数据',
          price: '3000.00',
          date: '2019-02-02',
          img: require('./good.png'),
          tag1: 'GF1',
          tag2: '10m',
          command: '500+条'
        },
        {
          name: 'GF1 WFV3 分辨率0.5m L1级数据',
          price: '3000.00',
          date: '2019-02-02',
          img: require('./good.png'),
          tag1: 'GF1',
          tag2: '10m',
          command: '500+条'
        },
        {
          name: 'GF1 WFV3 分辨率0.5m L1级数据',
          price: '3000.00',
          date: '2019-02-02',
          img: require('./good.png'),
          tag1: 'GF1',
          tag2: '10m',
          command: '500+条'
        },
        {
          name: 'GF1 WFV3 分辨率0.5m L1级数据',
          price: '3000.00',
          date: '2019-02-02',
          img: require('./good.png'),
          tag1: 'GF1',
          tag2: '10m',
          command: '500+条'
        }
      ],
      // 当前选中分类
      activeName: "1",
      // 子卫星选中
      sateSonName: [],
      // 卫星等级
      levelActiveName: [],
      // 当前分辨率
      resolveActiveName: [],
      // 价格排序
      priceSortName: "2",
      priceSortClass: [
        {id: 2, label: '销量', iconClass: 'el-icon-bottom'},
        {id: 1, label: '评论量', iconClass: 'el-icon-bottom'},
        {id: 4, label: '新品', iconClass: 'el-icon-bottom'},
        {id: 3, label: '价格', iconClass: 'el-icon-bottom-right'},
        {id: 5, label: '价格', iconClass: 'el-icon-top-right'},
      ],
      // 当前行业分类
      industyActiveName: "998",
      // 当前已选条件集合
      currentSelectArray: [],
      // 已选择id集合
      selectedIdArray: []
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.query.id) {
      this.industyActiveName = this.$route.query.id;
    }
    if (this.$route.query.goodsType) {
      this.industyActiveName = this.$route.query.goodsType
    }
    if (this.$route.query.softType) {
      this.goodactiveName = '3'
      this.goodid = this.$route.query.softType
    }
    let that = this;
    // 获取卫星类型
    this.initSatelliteType();
    // 获取卫星等级
    this.initSatelliteLevel();
    // 获取商品板块分类
    this.initGoodsClass();
    //获取商品分类
    this.getClassificationOfGoods()
    // 初始查询
    this.searchLoading = true;
    setTimeout(function () {
      that.searchSatelliteList();
    }, 1000)

  },
  computed: {},

  methods: {
    goodChange() {
      this.searchLoading = true;
      this.currentPage = 1;
      this.pagesize = 8;
      this.searchSatelliteList();
    },
    async getClassificationOfGoods() {
      let res = await this.$http
          .get(this.$const.RemoteSensingMall.ClassificationOfGoods, "")
      if (res.code === 200) {
        this.ClassificationOfGoods = res.data
        this.ClassificationOfGoods.unshift({name:'全部',id:''})
      }
    },

    GoodCategoryChange() {
      this.searchLoading = true;
      this.currentPage = 1;
      this.pagesize = 8;
      this.searchSatelliteList();
    },

    // 一级分类选择
    sateChange(e) {
      // console.log(e);
      if (e != '1') {
        // 获取当前父级的子卫星
        this.getSateSonList(e);
      } else {
        // 重置已选子卫星
        this.currentSelectArray = [];
        this.selectedIdArray = [];
        this.sateSonName = [];
        this.searchLoading = true;
        // 开启查询
        this.searchSatelliteList()
      }
    },
    // 卫星等级选择
    sateLevelChange(e) {
      // console.log(e);
      this.searchLoading = true;
      this.currentPage = 1;
      this.pagesize = 8;
      this.searchSatelliteList()
    },
    // 子类卫星选择
    sateSonChange(id, name) {
      // console.log(this.sateSonName,name);
      // console.log(this.currentSelectArray,name);
      // return false;
      if (this.currentSelectArray.length > 0) {
        const isExit = this.currentSelectArray.indexOf(name);
        // console.log(isExit);
        if (isExit > 0 || isExit == 0) {
          // console.log('存在删除');
          this.selectedIdArray.splice(isExit, 1);
          this.currentSelectArray.splice(isExit, 1)
        } else {
          // console.log('不存');
          this.selectedIdArray.push(id)
          this.currentSelectArray.push(name)
        }
      } else {
        // console.log('空数组');
        this.selectedIdArray.push(id)
        this.currentSelectArray.push(name);
      }
      console.log('已选择卫星：', this.currentSelectArray, this.selectedIdArray);
      this.searchLoading = true;
      this.currentPage = 1;
      this.pagesize = 8;
      this.searchSatelliteList();
    },
    // 已勾选卫星移除
    removeSatelliteFun(val, index) {
      console.log(val, index, this.sateSonName);
      this.sateSonName.splice(index, 1);
      this.currentSelectArray.splice(index, 1);
      this.selectedIdArray.splice(index, 1);
      this.currentPage = 1;
      this.searchSatelliteList();
    },
    // 分辨率选择
    resolveChange(e) {
      // console.log(e);
      this.searchLoading = true;
      this.currentPage = 1;
      this.pagesize = 8;
      this.searchSatelliteList();
    },
    // 行业分类选择
    industyChange(e) {
      this.searchLoading = true;
      this.currentPage = 1;
      this.pagesize = 8;
      this.searchSatelliteList();
    },
    // 价格排序选择
    priceSortChange(e) {
      console.log(e);
      this.searchLoading = true;
      this.currentPage = 1;
      this.searchSatelliteList();
    },
    initSatelliteType() {
      let satelliteClassTypeAll = [
        {id: '1', satelliteName: '全部'}
      ];
      this.$http
          .get(this.$const.searchOther.satelliteClass, "")
          .then((res) => {
            console.log("获取父级卫星分类:", res);
            if (res.code == 200) {
              this.classData = satelliteClassTypeAll.concat(res.data);
            } else {
              this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            this.$message.error(this.$PubText.InterfaceFail);
          });
    },
    getSateSonList(e) {
      this.$http
          .get(this.$const.searchOther.satelliteSon + e, "")
          .then((res) => {
            console.log("获取子卫星:", res);
            if (res.code == 200) {
              this.sateSonData = res.data;
            } else {
              this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            this.$message.error(this.$PubText.InterfaceFail);
          });
    },
    initSatelliteLevel() {
      this.$http
          .get(this.$const.searchOther.satelliteLevel, "")
          .then((res) => {
            console.log("获取卫星等级:", res);
            if (res.code == 200) {
              this.satelliteLevel = res.data
            } else {
              this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            this.$message.error(this.$PubText.InterfaceFail);
          });
    },
    initGoodsClass() {
      let productPlateArray = [
        {"id": "998", "plateName": "全部"}
      ];
      this.$http
          .get(this.$const.RemoteSensingMall.GoodsModuleClass, "")
          .then((res) => {
            console.log("获取行业分类:", res);
            if (res.code == 200) {
              this.plateClass = productPlateArray.concat(res.data);
              this.plateClass.push({"id": "999", "plateName": "基础数据"});
            } else {
              this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            this.$message.error(this.$PubText.InterfaceFail);
          });
    },
    handleSizeChange(val) {
      this.searchLoading = true;
      this.pagesize = val;
      console.log(`每页 ${val} 条`);
      this.searchSatelliteList();
    },
    handleCurrentChange(val) {
      this.searchLoading = true;
      this.currentPage = val;
      console.log(`当前页: ${val}`);
      this.searchSatelliteList();
    },
    searchSatelliteList() {
      let sendData
      if (this.goodactiveName === '1') {
        sendData = {
          goodsCategory: parseInt(this.goodactiveName),
          pageNum: this.currentPage,
          pageSize: this.pagesize,
          orderType: parseInt(this.priceSortName),

          goodsType: this.industyActiveName == '999' ? '1' : this.industyActiveName == '998' ? '' : '2',
          productLevel: this.levelActiveName,
          productPlateId: this.industyActiveName == '998' || this.industyActiveName == '999' ? "" : this.industyActiveName,
          resolutionRatio: this.resolveActiveName,
          satelliteList: this.sateSonName,
        }
      } else if (this.goodactiveName === '2') {
        sendData = {
          goodsCategory: parseInt(this.goodactiveName),
          pageNum: this.currentPage,
          pageSize: this.pagesize,
          orderType: parseInt(this.priceSortName),

          goodsType: this.industyActiveName == '999' ? '1' : this.industyActiveName == '998' ? '' : '2',
        }
      }else {
        sendData = {
          goodsCategory: parseInt(this.goodactiveName),
          pageNum: this.currentPage,
          pageSize: this.pagesize,
          goodsCategoryId: this.goodid,
          orderType: parseInt(this.priceSortName),
        }
      }

      console.log('已选中数据：', sendData);
      this.$http
          .post(this.$const.searchOther.searchGoodsList, sendData)
          .then((res) => {
            console.log("查询产品结果:", res);
            if (res.code == 200) {
              this.goodList = res.data.list;
              this.total = res.data.total;
            } else {
              this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            this.$message.error(this.$PubText.InterfaceFail);
          }).finally(cms => {
        this.searchLoading = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  padding-top: 20px;

  .selectArea {
    padding: 0 10px;

    .type {
      line-height: 30px;
    }
  }

  .sort {
    height: auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;
    padding: 0 10px;

    .currentSelect {
      color: #a1a1a1;
      font-size: 14px;
      margin-top: 10px;
      flex: 1;
      display: flex;

      .currentSelectTitle {
        line-height: 40px;
      }

      p {
        flex: 1;

        .el-tag {
          margin: 4px 5px;
        }
      }
    }

    .box {
      width: 250px;
      display: flex;
      justify-content: space-between;

      .sortitem {
        font-weight: 600;
        cursor: pointer;

        &:hover {
          color: #3868e9;
        }
      }

      .active {
        color: #3868e9;
      }
    }
  }

  .Display_area {
    margin-top: 10px;
    min-height: 400px;

    .display_area_box {
      display: flex;
      flex-wrap: wrap;
    }

    .block {
      text-align: center;
      margin: 5px 0;
    }
  }
}

.satelliteClass {
  display: flex;
  margin-top: 10px;
  border-bottom: 1px solid #eeeeee;

  .satelliteTitle {
    display: inline-block;
    width: 80px;
    font-size: 17px;
    font-weight: 600;
    text-align: justify;
    text-align-last: justify;
    color: #444;
    margin-right: 10px;
  }

  .satelliteWrap {
    flex: 12;
  }
}

.satelliteSonClass {
  display: flex;
  margin-top: 10px;
  border-bottom: 1px solid #eeeeee;

  .satelliteTitle {
    display: inline-block;
    width: 80px;
    font-size: 17px;
    font-weight: 600;
    text-align: justify;
    text-align-last: justify;
    color: #444;
    margin-right: 10px;
  }

  .satelliteWrap {
    flex: 12;
  }
}

.satelliteIndustry {
  display: flex;
  margin-top: 10px;
  border-bottom: 1px solid #eeeeee;

  .satelliteTitle {
    display: inline-block;
    width: 80px;
    font-size: 17px;
    font-weight: 600;
    text-align: justify;
    text-align-last: justify;
    color: #444;
    margin-right: 10px;
  }

  .satelliteWrap {
    flex: 12;
  }
}

.priceSort {
  display: flex;
  margin-top: 10px;
  border-bottom: 1px solid #eeeeee;

  .satelliteTitle {
    display: inline-block;
    width: 80px;
    font-size: 17px;
    font-weight: 600;
    text-align: justify;
    text-align-last: justify;
    color: #444;
    margin-right: 10px;
  }

  .satelliteWrap {
    flex: 12;
  }
}

.satelliteResolve {
  display: flex;
  margin-top: 10px;
  border-bottom: 1px solid #eeeeee;

  .satelliteTitle {
    display: inline-block;
    width: 80px;
    font-size: 17px;
    font-weight: 600;
    text-align: justify;
    text-align-last: justify;
    color: #444;
    margin-right: 10px;
  }

  .satelliteWrap {
    flex: 12;
  }
}

.satelliteLevel {
  display: flex;
  margin-top: 10px;
  border-bottom: 1px solid #eeeeee;

  .satelliteTitle {
    display: inline-block;
    width: 80px;
    font-size: 17px;
    font-weight: 600;
    text-align: justify;
    text-align-last: justify;
    color: #444;
    margin-right: 10px;
  }

  .satelliteWrap {
    flex: 12;
  }
}

.satelliteWrap /deep/ .el-radio-button {
  margin: 0px 10px 8px !important;
}

.satelliteWrap /deep/ .el-checkbox-button {
  margin: 0px 10px 8px !important;
}

.satelliteWrap /deep/ .el-radio-button .el-radio-button__inner {
  border: 0px !important;
  border-radius: 0% !important;
  padding: 8px !important;
  border: 1px solid #fff !important;
}

.satelliteWrap /deep/ .el-checkbox-button .el-checkbox-button__inner {
  border: 0px !important;
  border-radius: 0% !important;
  padding: 8px !important;
  border: 1px solid #fff !important;
}

.satelliteWrap /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #3868e9;
  background: #3867e90a !important;
  border: 1px solid #3868e9 !important;
  transition: none !important;
  box-shadow: none !important;
}

.satelliteWrap /deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  color: #3868e9;
  background: #3867e90a !important;
  border: 1px solid #3868e9 !important;
  transition: none !important;
  box-shadow: none !important;
}

.satelliteWrap /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner::after {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  width: 10px;
  height: 10px;
  background-image: url(/img/rightJiao.c55916ca.svg);
}

.satelliteWrap /deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner::after {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  width: 10px;
  height: 10px;
  background-image: url(/img/rightJiao.c55916ca.svg);
}
</style>
